<template>
  <span>
    <v-autocomplete
      v-model="data"
      :key="clear"
      :items="items"
      :loading="loading"
      :search-input.sync="search"
      item-text="name"
      item-value="name"
      placeholder="Select Category"
      :outlined="outlined"
    ></v-autocomplete>
  </span>
</template>

<script>
import { axios } from '../utils'
export default {
  props: { value: {}, outlined: { default: false }, clear: { default: true } },
  data() {
    return {
      items: [],
      data: '',
      loading: false,
      search: null
    }
  },
  mounted() {
    console.log(this.value)
  },

  watch: {
    search(value) {
      this.loading = true
      axios
        .get(`/api/categories?q=${value}&portal=yes`)
        .then(res => {
          this.items = res.data
          console.log(res.data)
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.loading = false
        })
    },
    data: function(value) {
      this.$emit('input', value)
    },
    value: function(value) {
      this.data = value
      this.items = [value]
    },
    clear: function() {
      this.items = []
      this.data = ''
      this.search = null
    }
  }
}
</script>

<style></style>
